// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-options-container {
    transition: height 0.5s ease-in-out;
}

.block-options-bar {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--gray-accent);
    border-radius: var(--border-radius) var(--border-radius) 0px 0px;
    padding: var(--padding-sm)
}

.block-options-bar label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.block-modal-container {
    height: calc(100% - 10px);
    overflow: auto;
    align-items: center;
}

.expand-block-modal {
    height: calc(80vh - 20px);
    min-width: 80vw;
}

.block-options-bar .settings-button {
    border-radius: var(--border-radius);
}

.block-options-bar .settings-open {
    background-color: var(--button-primary-clicked);
}

.block-options-container .block-options-bar .settings-open {
    background-color: var(--button-primary-clicked);
}

.block-options-bar-buttons {
    display: flex;
    height: 40px;
}

.pivot-table-block-container .table-options-bar label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

@media (max-width: 769px) and (orientation: portrait),
(max-height: 769px) and (orientation: landscape) {
    .expand-block-modal {
        height: calc(100vh - 50px);
        width: calc(100vw - 10px)
    }

    .block-options-bar-buttons button {
        margin-top: 0;
        margin-bottom: 0;
        margin-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/components/ECLBlockOptions.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;IACpC,gEAAgE;IAChE;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,cAAc;IAClB;AACJ","sourcesContent":[".block-options-container {\r\n    transition: height 0.5s ease-in-out;\r\n}\r\n\r\n.block-options-bar {\r\n    width: 100%;\r\n    height: 40px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: var(--gray-accent);\r\n    border-radius: var(--border-radius) var(--border-radius) 0px 0px;\r\n    padding: var(--padding-sm)\r\n}\r\n\r\n.block-options-bar label {\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.block-modal-container {\r\n    height: calc(100% - 10px);\r\n    overflow: auto;\r\n    align-items: center;\r\n}\r\n\r\n.expand-block-modal {\r\n    height: calc(80vh - 20px);\r\n    min-width: 80vw;\r\n}\r\n\r\n.block-options-bar .settings-button {\r\n    border-radius: var(--border-radius);\r\n}\r\n\r\n.block-options-bar .settings-open {\r\n    background-color: var(--button-primary-clicked);\r\n}\r\n\r\n.block-options-container .block-options-bar .settings-open {\r\n    background-color: var(--button-primary-clicked);\r\n}\r\n\r\n.block-options-bar-buttons {\r\n    display: flex;\r\n    height: 40px;\r\n}\r\n\r\n.pivot-table-block-container .table-options-bar label {\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n@media (max-width: 769px) and (orientation: portrait),\r\n(max-height: 769px) and (orientation: landscape) {\r\n    .expand-block-modal {\r\n        height: calc(100vh - 50px);\r\n        width: calc(100vw - 10px)\r\n    }\r\n\r\n    .block-options-bar-buttons button {\r\n        margin-top: 0;\r\n        margin-bottom: 0;\r\n        margin-left: 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
